import { render, staticRenderFns } from "./SingleBayView.vue?vue&type=template&id=4b8c8f78&scoped=true"
import script from "./SingleBayView.vue?vue&type=script&lang=ts"
export * from "./SingleBayView.vue?vue&type=script&lang=ts"
import style0 from "./SingleBayView.vue?vue&type=style&index=0&id=4b8c8f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c8f78",
  null
  
)

export default component.exports